import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Projects', path: '/projects' },
    { name: 'Contact', path: '/contact' },
  ];

  const services = [
    { name: 'Building & Construction', path: '/services#building' },
    { name: 'Civil Works', path: '/services#civil' },
    { name: 'Road Works', path: '/services#road' },
    { name: 'Water Infrastructure', path: '/services#water' },
    { name: 'Project Management', path: '/services#project' },
    { name: 'Consultancy', path: '/services#consultancy' },
  ];

  return (
    <footer className="bg-burale-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="mb-4">
              <img 
                src="/comp-logo.png" 
                alt="BURALE MAINTAINANCE & SUPPLIERS LTD" 
                className="h-16 w-auto object-contain mb-4 brightness-0 invert"
              />
            </div>
            <p className="text-gray-300 text-sm mb-4">
              We Build. We Connect. We Deliver.
            </p>
            <p className="text-gray-400 text-sm">
              Building Today. Creating Tomorrow.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-burale-gold">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-burale-teal transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-burale-gold">Services</h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service.path}>
                  <Link
                    to={service.path}
                    className="text-gray-300 hover:text-burale-teal transition-colors duration-200 text-sm"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-burale-gold">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-burale-teal mt-1 flex-shrink-0" />
                <span className="text-gray-300 text-sm">Eastleigh Mall, Nairobi<br />P.O. Box 78246 - 00507, NAIROBI</span>
              </li>
              <li className="flex items-start space-x-3">
                <Phone size={18} className="text-burale-teal mt-1 flex-shrink-0" />
                <span className="text-gray-300 text-sm">+254 721 542 569</span>
              </li>
              <li className="flex items-start space-x-3">
                <Mail size={18} className="text-burale-teal mt-1 flex-shrink-0" />
                <span className="text-gray-300 text-sm">info@buralesuppliers.co.ke</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <p className="text-center text-gray-400 text-sm">
            © {currentYear} Burale Maintainance and Suppliers Limited. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
